import { Injectable, signal } from '@angular/core';
import { Breakpoints } from '@circlek-global/lds-components';

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService {
  readonly isDesktop = signal(window.innerWidth > parseInt(Breakpoints.MD));

  onResize(): void {
    this.isDesktop.set(window.innerWidth > parseInt(Breakpoints.MD));
  }
}
